import { MessageResponse } from "./system/types";

export const serverMessages = (responseData: any): MessageResponse=> {   
    
    let message: MessageResponse;
    if (responseData.Error.status === 500) {
        message = {
            code: responseData.Error.status,
            message: ["Existe un error por favor comuniquese con Ing. Pablo Santacruz"]
        };
    }
    else {       
        
        const errorResponse = responseData.Error.message;        
        message = {
            code: responseData.Error.status,
            message: [errorResponse]
        };          
    }
    return message;  
};